import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';
import { VideoBlock } from '../../_blocks/VideoBlock';

export type TopVideoWidget = WidgetShape<VideoBlock, WidgetType.topvideo>;

/**
 * Top Video on home page.
 */
export function TopVideoWidget({ blocks, elementType, ...headerProps }: TopVideoWidget) {
  const { t } = useSonTranslation('Video');

  if (blocks[0] && isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.VIDEO}
      title={t('topvideo.widgetTitle')}
    >
      {blocks[0] && <VideoBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
